import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "element-loading-text": "正在加载数据，请稍候" }
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 移 交 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 取 消 ")

import { reactive, ref, unref } from 'vue';
import { FormRules, ElForm, ElMessage } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import { ContractTransferApi } from '../../../apis/contract/contract.api';
import { GetUserDpListApi } from '@/apis/accounts/accounts.api';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const elFormRef = ref<ComponentRef<typeof ElForm>>();

const state = reactive({
	show: false,
	loading: false,
	loadUsers: false,
	detail: {} as any,
	userList: [] as any[],
	title: '审批退回',
});

const formRules = reactive<FormRules>({
	to_emp_no: [{ required: true, message: '请选择需要接受的用户', trigger: 'blur' }],
	remark: [{ required: true, message: '审核批示不能为空', trigger: 'blur' }],
});

const schema = reactive<any>({
	id: '',
	revision: '',
	to_emp_no: '',
	remark: '',
});

const load = {
	getUserDpList: async () => {
		state.loadUsers = true;
		const { data } = await GetUserDpListApi();
		const userList = data ?? [];

		userList.forEach((user: any) => {
			user.label = `${user.label}(${user.value})`;
			user.key = user.value;
		});

		state.userList = userList;
		state.loadUsers = false;
	},
};

const actions = {
	/* 审批退回 */
	transfer: () => {
		unref(elFormRef)?.validate(async (isValid: boolean) => {
			if (!isValid) return;

			state.loading = true;

			const onSuccess = (res: any) => {
				const { succeeded, errors } = res;
				if (!succeeded) {
					ElMessage.error(errors);
				} else {
					ElMessage.success('移交成功');
					state.show = false;
				}
			};

			const onCatch = (err: any) => {
				ElMessage.error(err.message);
			};

			const onFinally = () => {
				state.loading = false;
				$emits('refresh');
			};

			await ContractTransferApi(unref(schema)).then(onSuccess).catch(onCatch).finally(onFinally);
		});
	},
};

/* 打开对话框 */
const showDialog = (contract: any) => {
	unref(schema).id = contract.id;
	unref(schema).revision = contract.revision;
	unref(schema).to_emp_no = '';
	unref(schema).remark = '';

	load.getUserDpList();

	state.detail = contract;
	state.show = true;
};

expose({ showDialog });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(state).title,
    style: {"width":"520px"}
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            style: {"width":"80px"},
            disabled: _unref(state).loading,
            onClick: actions.transfer
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            type: "info",
            size: "small",
            style: {"width":"80px"},
            disabled: _unref(state).loading,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(state).show = false))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          ref_key: "elFormRef",
          ref: elFormRef,
          model: _unref(schema),
          "label-position": "top",
          rules: _unref(formRules),
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "合同编号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).detail.no) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "合同名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).detail.name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "当前审批用户" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.apply_User,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).detail.apply_User) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "接收用户工号",
              prop: "to_emp_no"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select_v2, {
                  style: {"width":"480px"},
                  modelValue: _unref(schema).to_emp_no,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(schema).to_emp_no) = $event)),
                  filterable: "",
                  options: _unref(state).userList,
                  placeholder: "请选择接收用户工号",
                  loading: _unref(state).loadUsers,
                  disabled: _unref(state).loadUsers
                }, null, 8, ["modelValue", "options", "loading", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "移交原因",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(schema).remark,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(schema).remark) = $event)),
                  type: "textarea",
                  "show-word-limit": "",
                  rows: "4",
                  maxlength: "150",
                  placeholder: "请输入移交原因"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})